export default {
    'align-center': require('../vue/align-center.vue').default,
    'align-opposite': require('../vue/align-opposite.vue').default,
    avatar: require('../vue/avatar.vue').default,
    'button-slot': require('../vue/button-slot.vue').default,
    'block-text': require('../vue/block-text.vue').default,
    column: require('../vue/column.vue').default,
    'doc-description': require('../vue/doc-description.vue').default,
    'doc-example': require('../vue/doc-example.vue').default,
    'doc-props': require('../vue/doc-props.vue').default,
    gap: require('../vue/gap.vue').default,
    hint: require('../vue/hint.vue').default,
    'hint-content': require('../vue/hint-content.vue').default,
    icon: require('../vue/icon.vue').default,
    info: require('../vue/info.vue').default,
    locations: require('../vue/locations.vue').default,
    location: require('../vue/location.vue').default,
    'markers-map': require('../vue/markers-map.vue').default,
    'main-button': require('../vue/main-button.vue').default,
    row: require('../vue/row.vue').default,
    short: require('../vue/short.vue').default,
    'short-content': require('../vue/short-content.vue').default,
    'short-show-less': require('../vue/short-show-less.vue').default,
    'short-show-more': require('../vue/short-show-more.vue').default,
    'small-header': require('../vue/title-minor.vue').default,
    'split-line': require('../vue/split-line.vue').default,
    stars: require('../vue/stars.vue').default,
    'text-block': require('../vue/block-text.vue').default,
    'text-important': require('../vue/text-important.vue').default,
    'text-link': require('../vue/text-link.vue').default,
    'text-minor': require('../vue/text-minor.vue').default,
    'text-regular': require('../vue/text-regular.vue').default,
    'style-unsafe': require('../vue/style-unsafe.vue').default,
    'script-unsafe': require('../vue/script-unsafe.vue').default,
    'highlight-location': require('../vue/highlight-location.vue').default,
    'context-adaptive': require('../vue/context-adaptive.vue').default,
    'align-horizontal-center': require('../vue/align-horizontal-center.vue').default,
    'title-huge': require('../vue/title-huge.vue').default,
    'title-head': require('../vue/title-head.vue').default,
    'title-regular': require('../vue/title-regular.vue').default,
    'title-medium': require('../vue/title-medium.vue').default,
    'title-minor': require('../vue/title-minor.vue').default,
    'title-h1': require('../vue/title-huge.vue').default,
    'title-h2': require('../vue/title-head.vue').default,
    'title-h3': require('../vue/title-regular.vue').default,
    'title-h4': require('../vue/title-minor.vue').default,
    toggle: require('../vue/toggle.vue').default,
    'toggle-content': require('../vue/toggle-content.vue').default,
    'toggle-icon': require('../vue/toggle-icon.vue').default,
    'toggle-trigger': require('../vue/toggle-trigger.vue').default,
    pic: require('../vue/pic.vue').default,
    'table-body': require('../vue/table-body.vue').default,
    'table-cell': require('../vue/table-cell.vue').default,
    'table-row': require('../vue/table-row.vue').default,
    tooltip: require('../vue/tooltip.vue').default,
    conditional: require('../vue/conditional.vue').default,
    'tooltip-follow': require('../vue/tooltip-follow.vue').default,
    'print-page-break': require('../vue/print-page-break.vue').default,
    tpl: require('../vue/tpl.vue').default,
    unbreakable: require('../vue/unbreakable.vue').default,
    'unbreakable-part': require('../vue/unbreakable-part.vue').default,
    'scrollable-content': require('../vue/scrollable-content.vue').default,
    wrap: require('../vue/wrap.vue').default,
}
